import {get} from "./api";

export const authenticate = async () => {
  const {status, json} = await get("login");
  return status === 200;
}